/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IColonnaGenerale } from "../shared/interfaces";

const controller = 'ColonneGenerali';

const getColonneGenerali = (cancelToken?: CancelToken): Promise<IColonnaGenerale[]> => {
    return axiosInstance.get(`${controller}/GetColonneGenerali`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}
const getColonnaGenerale = (cancelToken?: CancelToken): Promise<IColonnaGenerale> => {
    return axiosInstance.get(`${controller}/GetColonnaGenerale`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateColonnaGenerale = (colonnaId: number, colonna: Partial<IColonnaGenerale>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/Update/${colonnaId}`, colonna, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const createColonnaGenerale = (colonna: Partial<IColonnaGenerale>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/Create`, colonna, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    getColonneGenerali,
    getColonnaGenerale,
    updateColonnaGenerale,
    createColonnaGenerale
}
